import { Handle, Position, NodeProps } from '@xyflow/react';

interface MenuNodeData {
  config: string;
  [key: string]: unknown;
}

interface MenuOption {
  label: string;
  value: string;
}

export function MenuNode({ data, selected }: NodeProps) {
  const d = data as MenuNodeData;
  const options = parseOptions(d.config);
  const hasTimeout = parseTimeoutMinutes(d.config) > 0;

  return (
    <div
      className="wt-rf-node wt-rf-node-menu"
      data-selected={selected ? 'true' : 'false'}
      style={{ borderColor: '#f59e0b', minWidth: 220 }}
    >
      <Handle type="target" position={Position.Top} className="wt-rf-port" />
      <div className="wt-rf-node-head" style={{ color: '#f59e0b' }}>
        <span className="wt-rf-node-dot" style={{ background: '#f59e0b' }} />
        <span>Menu</span>
      </div>
      {options.length === 0 ? (
        <div className="wt-rf-node-preview">(sem opções)</div>
      ) : (
        <ol className="wt-rf-menu-options">
          {options.map((opt, i) => (
            <li key={opt.value || i}>
              <span className="wt-rf-menu-option-label">{opt.label || `Opção ${i + 1}`}</span>
              {/* Handle posicionado pela CSS (top: 50% do <li> + right negativo pra estender alem do node) */}
              <Handle
                type="source"
                position={Position.Right}
                id={opt.value}
                className="wt-rf-port wt-rf-port-option"
              />
            </li>
          ))}
        </ol>
      )}
      {hasTimeout && (
        <div className="wt-rf-waitreply-out wt-rf-waitreply-timeout">
          <span>sem resposta</span>
          <Handle
            type="source"
            position={Position.Bottom}
            id="timeout"
            className="wt-rf-port wt-rf-port-timeout"
          />
        </div>
      )}
    </div>
  );
}

function parseTimeoutMinutes(configJson: string): number {
  try {
    const cfg = JSON.parse(configJson || '{}');
    const m = cfg.timeoutMinutes;
    return typeof m === 'number' && m > 0 ? m : 0;
  } catch {
    return 0;
  }
}

function parseOptions(configJson: string): MenuOption[] {
  try {
    const cfg = JSON.parse(configJson || '{}');
    if (Array.isArray(cfg.options)) {
      return cfg.options.map((o: MenuOption) => ({
        label: String(o.label ?? ''),
        value: String(o.value ?? ''),
      }));
    }
  } catch {
    /* fallthrough */
  }
  return [];
}
